export default __webpack_public_path__ + "static/media/ana.f21cf0bd.webp";